import React from 'react';
import {
  Container,
  LogoContainer,
  TitleContainer,
  Title,
  BottomContainer,
  TextContainer,
  Text,
  LineBreak,
  ButtonContainer,
  Button,
  TigoContaner,
} from './styles';
import {theme} from '../../styles/darkTheme';
import Logo from '../../components/atoms/Logo';
import {useTranslation} from '../../context/language';
import {useNavigate} from 'react-router-dom';
import TigoLogo from '../../assets/logos/logo-fihogar-dark.png';

const Welcome = () => {
  const history = useNavigate();
  const {title, text} = useTranslation();

  const goToRequestRemittance = (): void => {
    history('/request_remittance');
  };

  const goToChats = (): void => {
    history('/add_contact');
  };

  return (
    <Container theme={theme}>
      <LogoContainer>
        <Logo height={100} width={300} />
      </LogoContainer>
      <TitleContainer>
        <Title theme={theme}>{title.welcome}</Title>
      </TitleContainer>
      <BottomContainer theme={theme}>
        <TextContainer>
          <Text>{text.welcome[0]}</Text>
          <LineBreak />
          <Text>{text.welcome[1]}</Text>
          <LineBreak />
          <Text>
            {text.welcome[2]}
            <br />
            {text.welcome[3]}
            <br />
            {text.welcome[4]}
          </Text>
        </TextContainer>
        <TigoContaner>
          <Logo src={TigoLogo} width={145} height={95} />
        </TigoContaner>
        <ButtonContainer>
          <Button onClick={goToRequestRemittance}>
            {text.requestRemittance}
          </Button>
          <div style={{height: '10px'}} />
          <Button onClick={goToChats}>{text.requestChat}</Button>
        </ButtonContainer>
      </BottomContainer>
    </Container>
  );
};

export default Welcome;
